import { useEffect, useLayoutEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import AOS from 'aos'
import Header from '../componenets/inc/Header'
import Footer from '../componenets/inc/footer'
import FloatingButtons from '../features/core/components/FloatingButtons'
import useSponsorsActions from '../features/sponsors/hooks/useSponsorsActions'
import SliderDiamondSponsorsBanners from '../features/sponsors/components/banners/SliderDiamondSponsorsBanners'
import SliderGoldSponsorsBanners from '../features/sponsors/components/banners/SliderGoldSponsorsBanners'

export default function Layout() {
  const { lng } = useParams()
  const location = useLocation()
  const { getSponsorTypes } = useSponsorsActions()
  const isHome = location.pathname === `/${lng}/home`
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    })
    getSponsorTypes()
  }, [])

  return (
    <div
      className="relative"
      dir={lng === 'ar' ? 'rtl' : 'ltr'}
    >
      <Header />
      <Toaster
        position="top-left"
        reverseOrder={false}
      />
      <FloatingButtons />
      <Outlet />
      {!isHome && (
        <div className="mt-16 flex flex-col gap-8">
          <SliderDiamondSponsorsBanners />
          <SliderGoldSponsorsBanners />
        </div>
      )}
      <Footer />
    </div>
  )
}
